import { getTrainExceedConfig } from "@/api/chat";
import { internalStore } from "@/utils/LLM/localStore";
const loginData = internalStore.get("loginData");
// 取超标最强校验 超标不可见>不可定>可定 EXCEED_NOTBOOK_NOTVISIBLE > EXCEED_NOTBOOK_VISIBLE >EXCEED_BOOK
function getExceedConfiguration(args) {
  if (args && args.length > 0) {
    if (args.includes("EXCEED_NOTBOOK_NOTVISIBLE")) {
      return "EXCEED_NOTBOOK_NOTVISIBLE";
    } else if (args.includes("EXCEED_NOTBOOK_VISIBLE")) {
      return "EXCEED_NOTBOOK_VISIBLE";
    } else if (args.includes("EXCEED_BOOK")) {
      return "EXCEED_BOOK";
    } else {
      return "";
    }
  }
}
export default {
  namespaced: true,
  state: {
    account12306: {},
    noVerification: false,
    createOrderParams: null,
    train: {},
    trainData: {},
    standard: [],
    exceedBook: [],
    trainExceedBookVO: {},
    startUrl: ""
  },
  mutations: {
    setAccount12306(state, account) {
      state.account12306 = { ...state.account12306, ...account };
    },
    setNoVerification(state, payload) {
      state.noVerification = payload.noVerification;
    },
    setTrainParams(state, payload) {
      state.createOrderParams = payload;
    },
    ADD_TRAIN(state, data) {
      Object.assign(state.train, data);
    },
    ADD_TRAIN_DATA(state, data) {
      Object.assign(state.trainData, data);
    },
    CLEAR_TRAIN(state) {
      state.train = {};
      state.trainData = {};
    },
    ADD_STANDARD(state, data) {
      state.standard = data;
    },
    EXCEED_CONFIG(state, data) {
      state.exceedBook = data;
    },
    TRAIN_EXCEED_CONFIG(state, data) {
      state.trainExceedBookVO = data;
    },
    Set_START_URL(state, url) {
      state.startUrl = url;
    }
  },
  actions: {
    record12306Account({ commit }, account) {
      commit("setAccount12306", account);
    },
    setNoVerification({ commit }, noVerification) {
      commit("setNoVerification", noVerification);
    },
    addTrain({ commit }, data) {
      commit("ADD_TRAIN", data);
    },
    addTrainData({ commit }, data) {
      commit("ADD_TRAIN_DATA", data);
    },
    saveTravelStandard({ commit }, data) {
      if (data && data.length > 0) {
        data.forEach((item) => {
          if (item.TrainType) item.traintype = item.TrainType;
          if (item.SeatType) item.seattype = item.SeatType;
        });
      }
      commit("ADD_STANDARD", data);
    },
    trainExceedConfig({ commit, dispatch }, data) {
      getTrainExceedConfig(data).then((res) => {
        if (res.data.data) {
          commit("EXCEED_CONFIG", res.data.data);
          let isauto;
          data.travelExeedRuleParam.exceedUserVOList.forEach((item) => {
            if (item.phone === data.travelExeedRuleParam.phone) isauto = true;
          });
          dispatch("handleExceedBook", {
            exceedBookConfiguration: res.data.data,
            isauto
          });
        }
      });
    },
    handleExceedBook({ commit }, data) {
      const { phone } = loginData;
      const { exceedBookConfiguration, isauto } = data;
      const trainExceedBookVO = [];
      let bookConfigurations = [];
      // 当前出行人中无登录人 且超标数据返回数据大于2
      if (
        !isauto &&
        exceedBookConfiguration &&
        exceedBookConfiguration.length > 1
      ) {
        exceedBookConfiguration.forEach((val) => {
          if (val.userVO && phone !== val.userVO.phone) {
            bookConfigurations.push(val);
          }
        });
      } else {
        bookConfigurations = exceedBookConfiguration;
      }
      if (bookConfigurations && bookConfigurations.length > 0) {
        bookConfigurations.forEach((val) => {
          if (val.trainExceedBookVO && val.trainExceedBookVO.length > 0) {
            val.trainExceedBookVO.forEach((train) => {
              trainExceedBookVO.push(train);
            });
          }
        });
      }
      // 判断节点 审批前后 改签
      const beforeExceedBookVO = [];
      const afterExceedBookVO = [];
      const changeExceedBookVO = [];
      let exceedEffectNode = {};
      if (trainExceedBookVO && trainExceedBookVO.length > 0) {
        trainExceedBookVO.forEach((item) => {
          if (item.exceedEffectNode === "BILL_BEFORE") {
            beforeExceedBookVO.push(item.exceedControlMode);
          } else if (item.exceedEffectNode === "BILL_AFTER") {
            afterExceedBookVO.push(item.exceedControlMode);
          } else if (item.exceedEffectNode === "BILL_CHANGE") {
            changeExceedBookVO.push(item.exceedControlMode);
          }
        });
      }
      if (
        getExceedConfiguration(beforeExceedBookVO) ||
        getExceedConfiguration(afterExceedBookVO) ||
        getExceedConfiguration(changeExceedBookVO)
      ) {
        exceedEffectNode = {
          beforeExceedControlMode:
            getExceedConfiguration(beforeExceedBookVO) || "",
          afterExceedControlMode:
            getExceedConfiguration(afterExceedBookVO) || "",
          changeExceedControlMode:
            getExceedConfiguration(changeExceedBookVO) || ""
        };
      }
      commit("TRAIN_EXCEED_CONFIG", exceedEffectNode);
    },
    setStartUrl({ commit }, url) {
      commit("Set_START_URL", url);
    }
  }
};
